import * as React from "react";
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";

import * as styles from "./heroSwiper.module.scss";

export const HeroSwiper: React.FunctionComponent<
  React.PropsWithChildren<{}>
> = ({ children }) => {
  return (
    <Swiper className={styles.heroSwiper}>
      {React.Children.map(children, (c) => (
        <SwiperSlide className={styles.heroSwiperSlide}>{c}</SwiperSlide>
      ))}
    </Swiper>
  );
};
